import React, { useContext } from "react";
import { Section } from "../../../atoms/section";
import { Header } from "../../../molecules/header";
import { SECTIONS } from "../../../../constants/sections";
import { Icon } from "../../../atoms/icon";
import "./share-savings.css";
import { Button } from "../../../atoms/button/button";
import { Flex } from "../../../atoms/flex";
import { Link } from "../../../atoms/link";
import { Wave } from "../../../atoms/wave";
import { AnalyticsContext } from "../../../../utils/analytics/analytics-context";
import { Contact } from "../../../molecules/contact";
import { useStore } from "../../../../store";
import { MimboxData } from "../../../../interfaces/mimbox-data";
import { WEEK } from "../../../../constants/conversions";

/**
 * Saved section
 */
export const ShareSavings = () => {
  const { track } = useContext(AnalyticsContext);

  const {
    data = {} as MimboxData,
    loading,
    generatePdf,
    downloading,
  } = useStore();
  const today = new Date().getTime();

  const disabled = today - data?.firstTimeStamp < WEEK * 3; // Less than 3 weeks

  const disableDownload = () => {
    return loading || disabled;
  };

  return (
    <>
      <Wave className="fill-green" variant={3} />
      <Section className="bg-green" id={SECTIONS.SHARE_SAVINGS} wave>
        <Header
          className="download-header"
          title={SECTIONS.SHARE_SAVINGS}
          subTitle="En PDF skapas som visar en sammanfattning av dina miljömässiga besparingar."
          loading={loading}
        ></Header>
        <Flex className="download-pdf-container">
          {disabled && <div className="comming-soon">kommer snart!</div>}
          <Button
            className="download-pdf"
            disabled={disableDownload()}
            loading={downloading}
            onClick={() => {
              track("share", {
                content_type: "pdf",
                item_id: "Savings",
                method: "Download",
              });
              generatePdf();
            }}
          >
            Ladda ner PDF
          </Button>
        </Flex>

        <Flex className="social-media-icons">
          <Link url="https://www.linkedin.com/company/mimbly/">
            <Icon type="linkedin" size="s" loading={loading} />
          </Link>
          <Link url="https://www.facebook.com/Mimblyswe/">
            <Icon type="facebook" size="s" loading={loading} />
          </Link>
        </Flex>
      </Section>
      <Contact />
    </>
  );
};
